// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button_style[data-v-326ec528]{background-color:transparent!important;border-color:#e0e0e0!important}", ""]);
// Exports
module.exports = exports;
